<template>
  <ContactForm :open="openContactForm" @hide-modal="hideContactForm()" />
  <div class="relative inline-block text-left text-header-foreground">
    <Menu v-slot="{ open, close }" as="div" class="relative inline-block text-left">
      <div>
        <MenuButton :class="open ? 'rounded-t-sm' : 'rounded-sm'">
          <Button variant="outlined" color="current" class="gap-2">
            <outlineSupportAgent />
            {{ $t("Customer Support") }}
          </Button>
        </MenuButton>
      </div>
      <Transition
        enter="transition ease-out duration-100"
        enter-from="transform opacity-0 scale-95"
        enter-to="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leave-from="transform opacity-100 scale-100"
        leave-to="transform opacity-0 scale-95">
        <MenuItems
          v-show="open"
          class="absolute right-0 z-10 w-full origin-top-right bg-surface shadow-lg focus:outline-none"
          :class="open ? 'rounded-b-sm' : 'rounded-sm'"
          @mouseleave="close()">
          <div class="py-1">
            <MenuItem v-slot="{ active }">
              <span class="cursor-pointer" :class="menuItemClass(active)" @click="openContactForm = true">
                <EnvelopeIcon class="mr-3 h-5 w-5 text-foreground" />
                {{ $t("Contact support") }}
              </span>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <RouterLink to="/FAQ" :class="menuItemClass(active)">
                <QuestionMarkCircleIcon class="mr-3 h-5 w-5 text-foreground" />
                {{ $t("FAQ") }}
              </RouterLink>
            </MenuItem>
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  </div>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { EnvelopeIcon, QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import outlineSupportAgent from "~icons/ic/outline-support-agent";
import ContactForm from "@/components/ContactForm.vue";
import { ref } from "vue";
import { Button } from "@xs2event/js-lib/components";

const menuItemClass = (active) =>
  [
    active ? "bg-surface opacity-70 text-foreground" : "text-foreground",
    "group flex items-center px-4 py-2 text-sm",
  ].join(" ");

const openContactForm = ref(false);

const hideContactForm = () => {
  openContactForm.value = false;
};
</script>
